import { z } from 'zod';

/** 엔티티 목록 필터 form 스키마 */
export const entityFilterSchema = z.object({
  keyword: z.string().optional(),
  status: z.enum(['', 'DRAFT', 'REVIEW', 'PUBLISHED', 'ARCHIVED']).optional(),
});

export type EntityFilterForm = z.infer<typeof entityFilterSchema>;

/** diff 요청 스키마 (클라이언트 측 유효성 검사용) */
export const diffRequestSchema = z.object({
  entityId: z.number().int().positive(),
  from: z.number().int().positive(),
  to: z.number().int().positive(),
}).refine((d) => d.from < d.to, {
  message: 'from 은 to 보다 작아야 합니다',
  path: ['from'],
});

export type DiffRequestForm = z.infer<typeof diffRequestSchema>;
